import { render } from "./AddCotisations.vue?vue&type=template&id=45590cfe&scoped=true"
import script from "./AddCotisations.vue?vue&type=script&lang=js"
export * from "./AddCotisations.vue?vue&type=script&lang=js"

import "../assets/css/table.css?vue&type=style&index=0&id=45590cfe&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45590cfe"]])

export default __exports__